module.exports = __webpack_public_path__ + "ab00ea1d0d640817c702d885b93808b6.png";